import createDocumentData from "../../utils/createDocumentData";

import { Work } from "./types/Work";

export default function createWorkData(firebase, data) {
	return Work.parse(createDocumentData(firebase, "works", data));
}
